import React from "react";
import { Async } from "react-select";
import { getStores } from "../../../backend/stores";

import Overlay from "../../../components/overlay";
import Dialog from "../../../components/dialog";

export default function() {
  const { comments = [], storeSelect, loading, notis, notis_permanent,showNotiActionedOverlay,selectedNoti } = this.state;
  return (
    <div>
      <label>Store Location</label>
      <Async
        value={storeSelect}
        onChange={this._selectStore}
        loadOptions={getStores}
      />
      <div>
        {loading && <Overlay />}
        { (notis_permanent.length !== 0 || notis.length !== 0) && (<label>Notifications from Rug Doctor</label>)}
        {notis_permanent.length !== 0 && (
          <div className="noti_wrap permanent">
            { notis_permanent.map((noti, index) => this._renderNoti(noti, index)) }
          </div>
        )}
        {notis.length !== 0 && (
          <div className="noti_wrap">
            { notis.map((noti, index) => this._renderNoti(noti, index)) }
          </div>
        )}
        <label>Reports</label>
        <div className="comments_wrap">
        {(comments !== null && comments.length !== 0 && !loading ) ? (
          comments.map((comment, index) =>
          this._renderStoreComment(comment, index)
          )
        ) : (
          <div className="placeholder alert_wrap">
            {navigator.onLine ? "No reports" : "Could not retreive reports"}
          </div>
        )}
        </div>
        {showNotiActionedOverlay && (
          <Dialog close={this._closeNotiActionedOverlay}>
            <div>
              <h4>Remove note?</h4>
              <p></p>
              <div className="split-button-container">
                <button onClick={()=>{this._notiActioned(selectedNoti)}}>Yes</button>
                <button onClick={this._closeNotiActionedOverlay}>No</button>
              </div>
            </div>
          </Dialog>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/stores/comment-list/view.js